export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      portfolio: "Portfolio",
      industries: "Industries",
      blog: "Insights",
      contact: "Contact",
      cta: "Start a Project",
    },
    hero: {
      badge: "GULF REGION • B2B TECHNOLOGY PARTNER",
      title_1: "Empowering Businesses",
      title_2: "Through AI, Technology",
      title_3: "& Digital Growth.",
      subtitle: "Gulf TechLab helps companies across the Gulf transform ideas into scalable digital solutions — through AI, e-commerce, consultancy and performance marketing.",
      cta_primary: "Start Your Project",
      cta_secondary: "Explore Services",
      trust: "Trusted by startups, enterprises & government entities",
    },
    services: {
      eyebrow: "What we do",
      title: "Eight disciplines. One growth engine.",
      subtitle: "From strategy to execution, we deliver outcome-driven technology — built for the pace of the Gulf market.",
      learn: "Learn more",
    },
    why: {
      eyebrow: "Why Gulf TechLab",
      title: "A partner, not a vendor.",
      subtitle: "We operate as an extension of your team — regionally aware, technically deep, and accountable to outcomes.",
    },
    process: {
      eyebrow: "How we work",
      title: "A four-step path from idea to impact.",
      steps: [
        { label: "01", name: "Discover", desc: "We audit, research and align on the business goals that matter." },
        { label: "02", name: "Strategize", desc: "We design a roadmap, KPIs and a build plan that ships fast." },
        { label: "03", name: "Build", desc: "Cross-functional pods deliver the product, platform or campaign." },
        { label: "04", name: "Scale", desc: "We measure, iterate and compound growth over the long run." },
      ],
    },
    industries: {
      eyebrow: "Industries we serve",
      title: "Regional expertise across ten sectors.",
      subtitle: "Domain insight that accelerates delivery and reduces risk.",
    },
    cta: {
      title: "Let's build what's next — together.",
      subtitle: "Book a free strategy consultation with our senior team.",
      button: "Book a Consultation",
    },
    footer: {
      rights: "All rights reserved.",
      newsletter: "Get monthly insights on AI, growth & digital transformation.",
      subscribe: "Subscribe",
      placeholder: "your@email.com",
      company: "Company",
      solutions: "Solutions",
      resources: "Resources",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      cookies: "Cookie Policy",
    },
    contact: {
      title: "Tell us about your project",
      subtitle: "We reply within one business day.",
      name: "Full name",
      email: "Work email",
      phone: "Phone (optional)",
      company: "Company",
      inquiry: "Inquiry type",
      budget: "Estimated budget",
      message: "Project details",
      submit: "Send Inquiry",
      sent: "Thanks — we'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
    },
    startProject: {
      eyebrow: "START A PROJECT",
      title: "Tell us about your project",
      subtitle: "A few focused questions so our team can prepare before we talk — takes about 5 minutes.",
      stepLabel: "Step {current} of {total}",
      back: "Back",
      next: "Next",
      submit: "Submit assessment",
      submitting: "Submitting…",
      saving: "Saving draft…",
      saved: "Draft saved",
      required: "Required",
      selectPlaceholder: "Select an option",
      yes: "Yes",
      no: "No",
      min: "Min",
      max: "Max",
      validationError: "Please fill in the required fields before continuing.",
      submitError: "Something went wrong submitting your assessment. Please try again.",
      doneTitle: "Thank you — we've received your assessment.",
      doneBody: "Our team will review your answers and reach out within one business day. A copy of your submission has been sent to our team for review.",
      doneCta: "Back to home",
      resumeNote: "We've restored your in-progress assessment.",
      hintsLabel: "AI suggestions",
      hintsEmpty: "Looks good so far.",
      presubmitTitle: "Quick review before you submit",
      presubmitLabel: "AI review",
      presubmitEmpty: "Everything looks ready to go.",
      presubmitBack: "Go back and edit",
      presubmitConfirm: "Looks good — submit",
    },
    cookie: {
      text: "We use cookies to improve your experience and analyze traffic.",
      accept: "Accept",
      decline: "Decline",
    },
    concierge: {
      label: "AI Concierge",
      title: "Gulf TechLab Concierge",
      subtitle: "Ask about our services, portfolio, or industries",
      placeholder: "Ask a question…",
      send: "Send",
      thinking: "Thinking…",
      listening: "Listening…",
      uploading: "Reading file…",
      newChat: "New chat",
      privacyNote: "Answers are grounded in our site content. Nothing you type is stored — this chat resets when you close it.",
      chips: {
        services: "What services do you offer?",
        portfolio: "Show me some of your work",
        pricing: "How does pricing work?",
        contact: "I'd like to talk to someone",
      },
      micLabel: "Voice input",
      attachLabel: "Attach a file",
      speakerOnLabel: "Read replies aloud",
      speakerOffLabel: "Mute spoken replies",
      micError: "Couldn't access your microphone. You can still type your question.",
      uploadError: "Couldn't read that file. Try an image, PDF, or text file under 5MB.",
      fileTooLarge: "That file is over 5MB — please attach a smaller one.",
      unsupportedFile: "That file type isn't supported. Try an image, PDF, or text file.",
      errorGeneric: "Something went wrong. Please try again, or continue on WhatsApp.",
      handoffPrompt: "Want to continue with a real person? We can pick up right where this left off.",
      handoffCta: "Continue on WhatsApp",
      handoffFallback: "I'd like to talk to your team about my project.",
      attachedFile: "Attached",
      removeAttachment: "Remove attachment",
    },
  },
  ar: {
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      services: "الخدمات",
      portfolio: "أعمالنا",
      industries: "القطاعات",
      blog: "الرؤى",
      contact: "تواصل معنا",
      cta: "ابدأ مشروعك",
    },
    hero: {
      badge: "منطقة الخليج • شريك أعمال تقني",
      title_1: "تمكين الأعمال",
      title_2: "بالذكاء الاصطناعي والتقنية",
      title_3: "والنمو الرقمي.",
      subtitle: "تساعد خليج تك لاب الشركات في الخليج على تحويل الأفكار إلى حلول رقمية قابلة للتوسع عبر الذكاء الاصطناعي والتجارة الإلكترونية والاستشارات والتسويق.",
      cta_primary: "ابدأ مشروعك",
      cta_secondary: "استعرض الخدمات",
      trust: "شريك موثوق للشركات الناشئة والمؤسسات والجهات الحكومية",
    },
    services: {
      eyebrow: "ماذا نقدم",
      title: "ثمانية تخصصات. محرك نمو واحد.",
      subtitle: "من الاستراتيجية إلى التنفيذ، نقدم تقنية نتائج مبنية لسرعة السوق الخليجي.",
      learn: "اعرف المزيد",
    },
    why: {
      eyebrow: "لماذا خليج تك لاب",
      title: "شريك وليس مجرد مزود.",
      subtitle: "نعمل كامتداد لفريقك — بخبرة إقليمية وعمق تقني والتزام بالنتائج.",
    },
    process: {
      eyebrow: "كيف نعمل",
      title: "أربع خطوات من الفكرة إلى الأثر.",
      steps: [
        { label: "٠١", name: "الاكتشاف", desc: "نحلل ونبحث ونتفق على أهداف العمل المهمة." },
        { label: "٠٢", name: "التخطيط", desc: "نضع خارطة طريق ومؤشرات أداء وخطة تنفيذ سريعة." },
        { label: "٠٣", name: "البناء", desc: "فرق متعددة التخصصات تنفذ المنتج أو الحملة." },
        { label: "٠٤", name: "النمو", desc: "نقيس ونحسن ونوسع على المدى الطويل." },
      ],
    },
    industries: {
      eyebrow: "القطاعات",
      title: "خبرة إقليمية في عشرة قطاعات.",
      subtitle: "فهم عميق للمجال يسرّع التنفيذ ويقلل المخاطر.",
    },
    cta: {
      title: "لنبني ما هو قادم — معاً.",
      subtitle: "احجز استشارة استراتيجية مجانية مع فريقنا الأول.",
      button: "احجز استشارة",
    },
    footer: {
      rights: "جميع الحقوق محفوظة.",
      newsletter: "رؤى شهرية حول الذكاء الاصطناعي والنمو والتحول الرقمي.",
      subscribe: "اشتراك",
      placeholder: "بريدك@example.com",
      company: "الشركة",
      solutions: "الحلول",
      resources: "المصادر",
      legal: "قانوني",
      privacy: "سياسة الخصوصية",
      terms: "الشروط",
      cookies: "ملفات تعريف الارتباط",
    },
    contact: {
      title: "أخبرنا عن مشروعك",
      subtitle: "نرد خلال يوم عمل واحد.",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "الهاتف (اختياري)",
      company: "الشركة",
      inquiry: "نوع الاستفسار",
      budget: "الميزانية التقديرية",
      message: "تفاصيل المشروع",
      submit: "إرسال الاستفسار",
      sent: "شكراً — سنتواصل معك قريباً.",
      error: "حدث خطأ، حاول مرة أخرى.",
    },
    startProject: {
      eyebrow: "ابدأ مشروعاً",
      title: "أخبرنا عن مشروعك",
      subtitle: "بضعة أسئلة مركّزة ليتمكن فريقنا من الاستعداد قبل التحدث معك — تستغرق نحو 5 دقائق.",
      stepLabel: "الخطوة {current} من {total}",
      back: "رجوع",
      next: "التالي",
      submit: "إرسال التقييم",
      submitting: "جارٍ الإرسال…",
      saving: "جارٍ حفظ المسودة…",
      saved: "تم حفظ المسودة",
      required: "مطلوب",
      selectPlaceholder: "اختر خياراً",
      yes: "نعم",
      no: "لا",
      min: "الحد الأدنى",
      max: "الحد الأقصى",
      validationError: "يرجى تعبئة الحقول المطلوبة قبل المتابعة.",
      submitError: "حدث خطأ أثناء إرسال التقييم. يرجى المحاولة مرة أخرى.",
      doneTitle: "شكراً لك — لقد استلمنا تقييمك.",
      doneBody: "سيراجع فريقنا إجاباتك ويتواصل معك خلال يوم عمل واحد. تم إرسال نسخة من طلبك إلى فريقنا للمراجعة.",
      doneCta: "العودة إلى الصفحة الرئيسية",
      resumeNote: "لقد استعدنا تقييمك غير المكتمل.",
      hintsLabel: "اقتراحات ذكية",
      hintsEmpty: "تبدو الإجابات جيدة حتى الآن.",
      presubmitTitle: "مراجعة سريعة قبل الإرسال",
      presubmitLabel: "مراجعة ذكية",
      presubmitEmpty: "كل شيء يبدو جاهزاً.",
      presubmitBack: "الرجوع والتعديل",
      presubmitConfirm: "يبدو جيداً — إرسال",
    },
    cookie: {
      text: "نستخدم ملفات تعريف الارتباط لتحسين تجربتك وتحليل الزيارات.",
      accept: "قبول",
      decline: "رفض",
    },
    concierge: {
      label: "المساعد الذكي",
      title: "مساعد خليج تك لاب الذكي",
      subtitle: "اسأل عن خدماتنا أو أعمالنا أو القطاعات التي نخدمها",
      placeholder: "اكتب سؤالك…",
      send: "إرسال",
      thinking: "جاري التفكير…",
      listening: "جاري الاستماع…",
      uploading: "جاري قراءة الملف…",
      newChat: "محادثة جديدة",
      privacyNote: "الإجابات مبنية على محتوى موقعنا فقط. لا يُحفظ أي شيء تكتبه — تُمسح المحادثة عند إغلاقها.",
      chips: {
        services: "ما الخدمات التي تقدمونها؟",
        portfolio: "أرني بعض أعمالكم",
        pricing: "كيف يعمل التسعير؟",
        contact: "أود التحدث مع أحد الفريق",
      },
      micLabel: "إدخال صوتي",
      attachLabel: "إرفاق ملف",
      speakerOnLabel: "قراءة الردود صوتياً",
      speakerOffLabel: "كتم الردود الصوتية",
      micError: "تعذر الوصول إلى الميكروفون. يمكنك كتابة سؤالك بدلاً من ذلك.",
      uploadError: "تعذرت قراءة الملف. جرّب صورة أو PDF أو ملف نصي أقل من 5 ميجابايت.",
      fileTooLarge: "حجم الملف يتجاوز 5 ميجابايت — يرجى إرفاق ملف أصغر.",
      unsupportedFile: "نوع الملف غير مدعوم. جرّب صورة أو PDF أو ملف نصي.",
      errorGeneric: "حدث خطأ ما. حاول مرة أخرى، أو تابع عبر واتساب.",
      handoffPrompt: "تودّ المتابعة مع أحد أفراد الفريق؟ يمكننا المتابعة من حيث توقفنا هنا.",
      handoffCta: "تابع عبر واتساب",
      handoffFallback: "أود التحدث مع فريقكم بخصوص مشروعي.",
      attachedFile: "مُرفق",
      removeAttachment: "إزالة المرفق",
    },
  },
};
